<template>
  <div>
    <h3 class="mb-2">Dashboard</h3>
    <hr>
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="widget widget-stats bg-gradient-green">
          <div class="stats-icon stats-icon-lg"><i class="fa fa-globe fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title">PAGE VIEWS</div>
            <div class="stats-number">{{ stats.pageViews }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="widget widget-stats bg-gradient-blue">
          <div class="stats-icon stats-icon-lg"><i class="fa fa-users fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title">CUSTOMERS</div>
            <div class="stats-number">{{ stats.customers }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="widget widget-stats bg-gradient-purple">
          <div class="stats-icon stats-icon-lg"><i class="fa fa-cloud-download fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title">DOWNLOADS</div>
            <div class="stats-number">{{ stats.downloads }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-0 p-0">
      <div class="note note-purple m-b-15" v-if="(!products || products.length === 0) && !isLoading">
        <p class="p-0 m-0">There are no approved Catalogs.</p>
      </div>
      <div class="panel" v-if="products.length">
        <div class="panel-heading bg-light">
          <h4 class="panel-title">Catalogs Details</h4>
        </div>
        <div class="panel-body p-t-0">
          <div class="table-responsive">
            <table class="table table-striped m-b-0 table-valign-middle">
              <thead>
                <tr>
                  <th><span class="label"> Catalog Name</span></th>
                  <th class="text-center"><span class="label bg-gradient-green">Total Page Views</span></th>
                  <th class="text-center"><span class="label bg-gradient-blue">Total Customers</span></th>
                  <th class="text-center"><span class="label bg-gradient-purple">Total Downloads</span></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="product in products" :key="product._id">
                  <td>
                    <p>{{ product.name }}</p>
                  </td>
                  <td>
                    <div class="text-center">{{ product.stats.pageViews }}</div>
                  </td>
                  <td>
                    <div class="text-center">{{ product.stats.users }}</div>
                  </td>
                  <td>
                    <div class="text-center">{{ product.stats.downloads }}</div>
                  </td>
                  <td>
                    <div class="text-center">
                      <router-link :to="{ name: 'Product', params: { slug: product.slug }}" class="btn btn-sm btn-primary get-started rounded-pill" style="width: max-content;">Catalog</router-link>
                    </div>
                  </td>
                  <td>
                    <div class="text-center">
                      <router-link :to="{ name: 'DashboardReviewAdmin', params: { slug: product.slug }}" class="btn btn-sm btn-primary get-started rounded-pill">Reviews</router-link>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuex from 'vuex'
const _ = require('lodash')
export default {
  components: {},
  name: 'dashboard',
  data() {
    return {
      isLoading: true,
      stats: {
        pageViews: 0,
        customers: 0,
        downloads: 0
      },
      products: []
    }
  },
  created: function () {
    this.fetchData().then(
      products => {
        this.products = products.filter(product => product.status === 'approved');
        this.calculateStats();
        this.isLoading = false;
      },
      () => { this.isLoading = false }
    )
  },
  computed: {
    ...Vuex.mapGetters(['currentUser'])
  },
  methods: {
    fetchData() {
      return this.$http
        .get('product/admin')
        .then(resp => { return resp.data })
    },
    calculateStats() {
      this.stats.pageViews = this.products.reduce((total, product) => total + product.stats.pageViews, 0);
      this.stats.customers = this.products.reduce((total, product) => total + product.stats.users, 0);
      this.stats.downloads = this.products.reduce((total, product) => total + product.stats.downloads, 0);
    }
  }
}
</script>
<style >
.account-container .account-body {
  margin-left: 300px;
  padding: 20px 30px;
}
h3 {
  font-size: 24px;
}

.h1,
.h2,
.h3,
h1,
h2,
h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}
.row:before {
  display: table;
  content: " ";
}
@media (min-width: 1200px) {
  .col-lg-4 {
    width: 33.33333333%;
  }
}
.widget.widget-stats {
  position: relative;
}
.widget {
  color: #fff;
  padding: 15px;
  overflow: hidden;
  border-radius: 3px;
  margin-bottom: 20px;
}
.bg-gradient-green {
    background: linear-gradient(135deg,#34babb,#00acac)!important;
}
.row:after {
    clear: both;
}
.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}
</style>


// WEBPACK FOOTER //
// src/admin/views/Dashboard.vue